import React, { FunctionComponent } from 'react'
import useTranslation from '../../hooks/useTranslation'
import useOnMount from '../../hooks/useOnMount'
import style from './checkout.css'
import { ROUTE_CHECKOUT } from '../../constants/routes'

export type Props = {
    checkoutIsEnabled: boolean
    startCheckout: Function
    trampolineIsEnabled: boolean
    returnUrlWithHeadersEnabled: boolean
    vehicleCodeRequestPending: boolean
}

const Checkout: FunctionComponent<Props> = (props) => {
    const { checkoutIsEnabled, startCheckout, trampolineIsEnabled, returnUrlWithHeadersEnabled, vehicleCodeRequestPending } = props
    const { t } = useTranslation()

    useOnMount(() => {
        const alreadyFinished = new URLSearchParams(window.location.search).get('configuration_process') === 'finished'

        if (returnUrlWithHeadersEnabled && alreadyFinished) {
            return
        }

        if (checkoutIsEnabled || trampolineIsEnabled && !alreadyFinished) {
            startCheckout()
        }
    })

    return (
        <div className={style.container} data-testid={`page-${ROUTE_CHECKOUT}`}>
            <section className={style.headerContainer} data-testid="checkout-header-container">
                {trampolineIsEnabled || returnUrlWithHeadersEnabled
                    ? (<h3 data-testid="checkout-trampoline-text"> {vehicleCodeRequestPending ? t('loading') : t('checkout.trampoline')}</h3>)
                    : (
                        <>
                            <h1 data-testid="checkout-heading">
                                {t('checkout.heading')}
                            </h1>

                            <p data-testid="checkout-info-text">
                                {t('checkout.infoText')}
                            </p>
                        </>
                    )}
            </section>
        </div>
    )
}

export default Checkout
